// extracted by mini-css-extract-plugin
export var chevron = "_10-d";
export var disabled = "_10-b";
export var error = "_10-c";
export var hideBorder = "_10-1";
export var icon = "_10-e";
export var input = "_10-0";
export var large = "_10-f";
export var open = "_10-9";
export var placeholder = "_10-a";
export var regular = "_10-5";
export var singleRowInput = "_10-2";
export var singleSelectInput = "_10-3 _10-0";
export var small = "_10-4";
export var spinnerContainer = "_10-i";
export var tag = "_10-7";
export var tagsContainer = "_10-8";
export var tagsInput = "_10-6 _10-0";
export var xSmall = "_10-g";
export var xxSmall = "_10-h";